/* eslint-disable */

const Vue = require('vue/dist/vue');
const moment = require('moment');

Vue.config.silent = true;
Vue.config.devtools = false;
Vue.config.productionTip = false;

const { apiFetch } = wp;

const DEFAULT_PAGE = 1;
const DEFAULT_PER_PAGE = 10;

const PostColumn = Vue.component( 'post-column', {
    template: '#template-post-column',
    props: {
        post: {
            type: Object,
            required: true
        }
    }
});

const CategoryCheckbox = Vue.component( 'category-checkbox', {
    template: '#template-category-checkbox',
    props: {
        category: {
            type: Object,
            required: true
        }
    }
});

const ArchiveSearch = Vue.component( 'archive-search', {
    template: '#template-archive-search',
    components: {
        PostColumn,
        CategoryCheckbox
    },
    props: {
        categories: {
            type: Array,
            required: true
        },
        sortOptions: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            total: 0,
            totalPages: 0,
            query: '',
            posts : [],
            filters: [],
            noResultsFound : false,
            isLoading: false,
            loadingMore: false,
            per_page: DEFAULT_PER_PAGE,
            page: DEFAULT_PAGE,
            orderby: 'date',
            order: 'desc'
        }
    },
    created() {
        this.search();
    },
    methods: {
        _resetPagination() {
            this.page = DEFAULT_PAGE;
            this.per_page = DEFAULT_PER_PAGE;
        },
        setOrder( e ) {
            let orderBits = e.target.value.split('.');
            this.orderby = orderBits[0];
            this.order = orderBits[1];
            this._resetPagination();
            this.search();
        },
        search( props = {}, append = false ) {

            if( append ) {
                this.loadingMore = true;
            } else {
                this.isLoading = true;
            }

            let defaults = {
                per_page: this.per_page,
                page: this.page,
                orderby: this.orderby,
                order: this.order,
                template_slug: 'template-parts/grid/post',
                template_name: 'secondary'
            };

            let getProps = { ... defaults, ...props };

            if( this.query !== '' ) {
                getProps.search = this.query;
            }

            if( this.filters.length > 0 ) {
                getProps.categories = this.filters;
            }

            const path = 'wp/v2/posts?' + jQuery.param( getProps );

            apiFetch.use( ( options, next ) => {
                return next({
                    ...options,
                    parse: false
                }).then( response => {

                    if( Array.isArray( response ) ) {
                        return response;
                    }

                    this.total = response.headers && response.headers.get( 'X-WP-Total' );
                    this.totalPages = response.headers && response.headers.get( 'X-WP-TotalPages' );

                    return response.json();
                });
            });

            apiFetch({ path }).then( posts => {
                this.noResultsFound = false;
                if( append ) {
                    this.posts = this.posts.concat( posts );
                    this.loadingMore = false;
                    this.page = getProps.page;
                } else {
                    this.posts = posts;
                    this.isLoading = false;
                }

                if( this.posts.length === 0 ) {
                    this.noResultsFound = true;
                }
            });

            // ga( 'send', 'event', 'internal search', 'search', this.query );

            ga('send', {
                hitType: 'event',
                eventCategory: 'internal search',
                eventAction: 'search',
                eventLabel: this.query
            });

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'ajaxSuccess',
                'eventCategory': 'internal search',
                'eventAction': 'search',
                'eventLabel': this.query
            });
        },
        loadMore() {
            this.search({ page: this.page + 1 }, true );
        },
        applyFilters() {
            this._resetPagination();
            this.search();
        },
        resetFilters() {
            this.filters = [];
            this._resetPagination();
            this.search();
        }
    }
});

new Vue({
    el: '#archive-search',
    components: {
        ArchiveSearch
    }
});